import { CurrencyAttributes, CurrencyI18n, CurrencyI18nAttributes } from './types/currency';
import { ExpirationType } from './types/expiration';
import { defaultCurrencyImage } from '../constants';
import { uuid } from '../utils';

export const defaultCurrencyI18nAttributes: { [key: string]: CurrencyI18nAttributes } = {
  fr: {
    name: 'Points',
    description: 'Points',
    image: defaultCurrencyImage,
  },
  en: {
    name: 'Points',
    description: 'Points',
    image: defaultCurrencyImage,
  },
  nl: {
    name: 'Punten',
    description: 'Punten',
    image: defaultCurrencyImage,
  },
};

export function createDefaultCurrencyI18nAttributes(languages: string[]): {
  [key: string]: CurrencyI18nAttributes;
} {
  return Object.fromEntries(
    languages.map(language => [
      language,
      defaultCurrencyI18nAttributes[language] || defaultCurrencyI18nAttributes.en,
    ]),
  );
}

export function createDefaultCurrencyAttributes({
  i18nAttributes,
  languages = ['en'],
}: {
  i18nAttributes?: CurrencyI18n;
  languages?: string[];
} = {}): CurrencyAttributes {
  return {
    id: uuid(),
    i18nAttributes: i18nAttributes || createDefaultCurrencyI18nAttributes(languages),
    expiration: {
      type: ExpirationType.NONE,
    },
  } as CurrencyAttributes;
}

export function getImage(currency: CurrencyAttributes | undefined, locale: string | undefined) {
  if (!currency) {
    return defaultCurrencyImage;
  }

  let currentLocale = locale || Object.keys(currency.i18nAttributes)[0];

  if (!currency.i18nAttributes[currentLocale]) {
    const [fallbackLocale] = Object.keys(currency.i18nAttributes);
    currentLocale = fallbackLocale;
  }

  return currency.i18nAttributes?.[currentLocale]?.image || defaultCurrencyImage;
}
